import { render, staticRenderFns } from "./TestPaperUser.vue?vue&type=template&id=77071290&scoped=true"
import script from "./TestPaperUser.vue?vue&type=script&lang=js"
export * from "./TestPaperUser.vue?vue&type=script&lang=js"
import style0 from "./TestPaperUser.vue?vue&type=style&index=0&id=77071290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77071290",
  null
  
)

export default component.exports